// Calculadora de Frete Versátil - Tema MPN-On
// Suporta múltiplas opções: Frete Real (Yampi), Frete por Região, Frete Grátis

document.addEventListener('DOMContentLoaded', function() {
  const zipInput = document.getElementById('shipping-zip-code');
  const calculateBtn = document.getElementById('calculate-shipping-btn');
  const resultsDiv = document.getElementById('shipping-results');
  
  if (!zipInput || !calculateBtn || !resultsDiv) return;
  
  // Obter configurações do tema (injetadas via Liquid)
  const config = window.shippingCalculatorConfig || {
    mode: 'region', // 'yampi', 'region', 'free', 'free_above'
    yampiAlias: '',
    yampiToken: '',
    yampiSecretKey: '',
    freeShippingThreshold: 0,
    regionalRates: {
      'sul': { price: 15.00, days: '5-7' },
      'sudeste': { price: 15.00, days: '5-7' },
      'centro-oeste': { price: 20.00, days: '7-10' },
      'nordeste': { price: 25.00, days: '8-12' },
      'norte': { price: 25.00, days: '10-15' }
    }
  };
  
  // Máscara de CEP
  zipInput.addEventListener('input', function(e) {
    let value = e.target.value.replace(/\D/g, '');
    if (value.length > 5) {
      value = value.substring(0, 5) + '-' + value.substring(5, 8);
    }
    e.target.value = value;
  });
  
  // Calcular frete
  calculateBtn.addEventListener('click', function() {
    const zipCode = zipInput.value.replace(/\D/g, '');
    
    if (zipCode.length !== 8) {
      alert('Por favor, digite um CEP válido');
      return;
    }
    
    calculateBtn.textContent = 'Calculando...';
    calculateBtn.disabled = true;
    resultsDiv.innerHTML = '<p style="color: #666; font-size: 14px; padding: 15px;">Buscando opções de frete...</p>';
    resultsDiv.style.display = 'block';
    
    // Escolher método baseado na configuração
    switch(config.mode) {
      case 'yampi':
        calculateYampiShipping(zipCode);
        break;
      case 'region':
        calculateRegionalShipping(zipCode);
        break;
      case 'free':
        displayFreeShipping();
        break;
      case 'free_above':
        calculateFreeAbove(zipCode);
        break;
      default:
        calculateRegionalShipping(zipCode);
    }
  });
  
  // OPÇÃO 1: Frete Real via API Yampi
  function calculateYampiShipping(zipCode) {
    if (!config.yampiAlias || !config.yampiToken || !config.yampiSecretKey) {
      resultsDiv.innerHTML = '<p style="color: #e74c3c; font-size: 14px; padding: 15px;">Configure as credenciais da Yampi no editor de temas.</p>';
      resultsDiv.style.display = 'block';
      calculateBtn.textContent = 'Calcular';
      calculateBtn.disabled = false;
      return;
    }
    
    const productData = getProductData();
    const apiUrl = `https://api.dooki.com.br/v2/${config.yampiAlias}/logistics/shipping-costs`;
    
    // CORREÇÃO: Removido skus_ids para evitar erro 422
    // A API usará as configurações padrão da loja (peso/dimensões)
    const payload = {
      zipcode: zipCode,
      total: productData.price
    };
    
    fetch(apiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'User-Token': config.yampiToken,
        'User-Secret-Key': config.yampiSecretKey
      },
      body: JSON.stringify(payload)
    })
    .then(response => {
      if (!response.ok) throw new Error('Erro na API: ' + response.status);
      return response.json();
    })
    .then(data => {
      if (data.data && Array.isArray(data.data)) {
        displayShippingOptions(data.data);
      } else if (data.data) {
        displayShippingOptions([data.data]);
      } else {
        throw new Error('Formato de resposta inválido');
      }
    })
    .catch(error => {
      console.error('Erro ao calcular frete:', error);
      // Fallback para frete regional
      calculateRegionalShipping(zipCode);
    })
    .finally(() => {
      calculateBtn.textContent = 'Calcular';
      calculateBtn.disabled = false;
    });
  }
  
  // OPÇÃO 2: Frete por Região (Simples e Sempre Funciona)
  function calculateRegionalShipping(zipCode) {
    const region = getRegionFromZipCode(zipCode);
    const rate = config.regionalRates[region];
    
    if (!rate) {
      resultsDiv.innerHTML = '<p style="color: #e74c3c; font-size: 14px; padding: 15px;">CEP não encontrado.</p>';
      resultsDiv.style.display = 'block';
      calculateBtn.textContent = 'Calcular';
      calculateBtn.disabled = false;
      return;
    }
    
    const options = [
      {
        icon: '📦',
        name: 'Entrega Padrão',
        deliveryTime: `${rate.days} dias úteis`,
        price: `R$ ${rate.price.toFixed(2).replace('.', ',')}`
      }
    ];
    
    displayShippingOptions(options);
    calculateBtn.textContent = 'Calcular';
    calculateBtn.disabled = false;
  }
  
  // OPÇÃO 3: Frete Grátis
  function displayFreeShipping() {
    const options = [
      {
        icon: '🎁',
        name: 'Frete Grátis',
        deliveryTime: '5-10 dias úteis',
        price: 'Grátis'
      }
    ];
    
    displayShippingOptions(options);
    calculateBtn.textContent = 'Calcular';
    calculateBtn.disabled = false;
  }
  
  // OPÇÃO 4: Frete Grátis Acima de X
  function calculateFreeAbove(zipCode) {
    const productData = getProductData();
    
    if (productData.price >= config.freeShippingThreshold) {
      displayFreeShipping();
    } else {
      const remaining = config.freeShippingThreshold - productData.price;
      const options = [
        {
          icon: '📦',
          name: 'Entrega Padrão',
          deliveryTime: '5-10 dias úteis',
          price: 'R$ 15,00'
        },
        {
          icon: '🎁',
          name: `Frete Grátis acima de R$ ${config.freeShippingThreshold.toFixed(2).replace('.', ',')}`,
          deliveryTime: `Faltam R$ ${remaining.toFixed(2).replace('.', ',')}`,
          price: 'Adicione mais produtos'
        }
      ];
      
      displayShippingOptions(options);
    }
    
    calculateBtn.textContent = 'Calcular';
    calculateBtn.disabled = false;
  }
  
  // Função auxiliar: Obter dados do produto
  function getProductData() {
    let price = 0;
    const priceElement = document.querySelector('[data-product-price]') || 
                        document.querySelector('.product__price .price') ||
                        document.querySelector('.price');
    
    if (priceElement) {
      const priceText = priceElement.textContent.replace(/[^\d,]/g, '').replace(',', '.');
      price = parseFloat(priceText) || 0;
    }
    
    let variantId = 0;
    const variantElement = document.querySelector('[name="id"]');
    if (variantElement) {
      variantId = parseInt(variantElement.value) || 0;
    }
    
    return { price, variantId };
  }
  
  // Função auxiliar: Determinar região pelo CEP
  function getRegionFromZipCode(zipCode) {
    const cep = parseInt(zipCode);
    
    // Sul: RS, SC, PR
    if ((cep >= 80000 && cep <= 87999) || // PR
        (cep >= 88000 && cep <= 89999) || // SC
        (cep >= 90000 && cep <= 99999)) { // RS
      return 'sul';
    }
    
    // Sudeste: SP, RJ, ES, MG
    if ((cep >= 1000 && cep <= 19999) || // SP
        (cep >= 20000 && cep <= 28999) || // RJ
        (cep >= 29000 && cep <= 29999) || // ES
        (cep >= 30000 && cep <= 39999)) { // MG
      return 'sudeste';
    }
    
    // Centro-Oeste: GO, MT, MS, DF
    if ((cep >= 70000 && cep <= 72799) || // DF
        (cep >= 72800 && cep <= 76799) || // GO
        (cep >= 77000 && cep <= 77999) || // TO
        (cep >= 78000 && cep <= 78899) || // MT
        (cep >= 79000 && cep <= 79999)) { // MS
      return 'centro-oeste';
    }
    
    // Nordeste: BA, SE, AL, PE, PB, RN, CE, PI, MA
    if ((cep >= 40000 && cep <= 48999) || // BA
        (cep >= 49000 && cep <= 49999) || // SE
        (cep >= 50000 && cep <= 56999) || // PE
        (cep >= 57000 && cep <= 57999) || // AL
        (cep >= 58000 && cep <= 58999) || // PB
        (cep >= 59000 && cep <= 59999) || // RN
        (cep >= 60000 && cep <= 63999) || // CE
        (cep >= 64000 && cep <= 64999) || // PI
        (cep >= 65000 && cep <= 65999)) { // MA
      return 'nordeste';
    }
    
    // Norte: AM, RR, AP, PA, TO, RO, AC
    if ((cep >= 68900 && cep <= 68999) || // AC
        (cep >= 69000 && cep <= 69299) || // AM
        (cep >= 69300 && cep <= 69399) || // RR
        (cep >= 69400 && cep <= 69899) || // AM
        (cep >= 69900 && cep <= 69999) || // RR
        (cep >= 76800 && cep <= 76999) || // RO
        (cep >= 66000 && cep <= 68899)) { // PA/AP
      return 'norte';
    }
    
    return 'sudeste'; // Default
  }
  
  // Exibir opções de frete
  function displayShippingOptions(rates) {
    if (!rates || rates.length === 0) {
      resultsDiv.innerHTML = '<p style="color: #e74c3c; font-size: 14px; padding: 15px;">Nenhuma opção de frete disponível.</p>';
      resultsDiv.style.display = 'block';
      return;
    }
    
    let html = '<div style="border-top: 1px solid #e0e0e0; padding-top: 15px;">';
    html += '<p style="font-size: 14px; font-weight: 600; margin-bottom: 10px; color: #333;">Opções de Entrega:</p>';
    
    rates.forEach(rate => {
      // Adaptar para diferentes formatos de resposta
      let icon = rate.icon || '📦';
      let name = rate.name || rate.service_display_name || rate.service_name || 'Entrega';
      let deliveryTime = rate.deliveryTime || rate.formated_delivery_time || 
                        (rate.delivery_time ? `${rate.delivery_time} dias úteis` : 'Consultar prazo');
      let price = rate.price || rate.formated_price || 'Consultar';
      
      // Se price é número, formatar
      if (typeof price === 'number') {
        price = `R$ ${price.toFixed(2).replace('.', ',')}`;
      }
      
      html += `
        <div style="display: flex; justify-content: space-between; align-items: center; padding: 12px; background: #fff; border: 1px solid #e0e0e0; border-radius: 4px; margin-bottom: 8px;">
          <div style="display: flex; align-items: center; gap: 10px;">
            <span style="font-size: 20px;">${icon}</span>
            <div>
              <p style="margin: 0; font-size: 14px; font-weight: 600; color: #333;">${name}</p>
              <p style="margin: 0; font-size: 12px; color: #666;">${deliveryTime}</p>
            </div>
          </div>
          <p style="margin: 0; font-size: 14px; font-weight: 600; color: #00bd58;">${price}</p>
        </div>
      `;
    });
    
    html += '</div>';
    resultsDiv.innerHTML = html;
    resultsDiv.style.display = 'block';
  }
});
